'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import NestTab from '@/components/tabs/NestTab';
import Image from 'next/image';
import OnboardingWrapper from '@/components/wrappers/OnboardingWrapper';
import { useQuery } from 'urql';
import { NeedOnboarding } from '@/graphql/queries';
import clsx from 'clsx';
const tabs = [{
  id: 'flock',
  label: 'Flock',
  icon: '/flock.png'
}, {
  id: 'nest',
  label: 'Nest',
  icon: '/nest.png'
}, {
  id: 'way',
  label: 'Way',
  icon: '/way.png'
}];
export default function Home() {
  const $ = _c(21);
  const [activeTab, setActiveTab] = useState("nest");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      query: NeedOnboarding
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [needOnboardingQuery] = useQuery(t0);
  const t1 = !needOnboardingQuery.data.me.avatar;
  let t2;
  if ($[1] !== activeTab) {
    t2 = activeTab === "flock" && <div className="p-8 text-center text-2xl text-muted">Flock tab coming soon</div>;
    $[1] = activeTab;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== activeTab) {
    t3 = activeTab === "nest" && <NestTab />;
    $[3] = activeTab;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== activeTab) {
    t4 = activeTab === "way" && <div className="p-8 text-center text-2xl text-muted">Way tab coming soon</div>;
    $[5] = activeTab;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex-1">{t2}{t3}{t4}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== activeTab) {
    t6 = tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={clsx("flex flex-col items-center gap-1 px-6 py-2 transition-colors", activeTab === tab.id ? "text-primary" : "text-muted")}><Image src={tab.icon} alt={tab.label} width={32} height={32} /><span className="text-xs font-heading">{tab.label}</span></button>);
    $[11] = activeTab;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <div className="fixed bottom-0 left-0 right-0 m-4 rounded-full backdrop-blur-3xl backdrop-opacity-90 border-t border-secondary/20 flex justify-around py-2 z-50">{t6}</div>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <div className="min-h-screen flex flex-col">{t5}{t7}</div>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t8) {
    t9 = <OnboardingWrapper needsOnboarding={t1}>{t8}</OnboardingWrapper>;
    $[18] = t1;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}